(function() {
  function tryBindOverlay() {
    var overlay = document.querySelector('.js-overlay');
    if (!overlay) {
      setTimeout(tryBindOverlay, 300);
      return;
    }
    var observer = new MutationObserver(function() {
      var isOpen = overlay.classList.contains('is-visible');
      document.body.classList.toggle('overlay-is-open', isOpen);
    });
    observer.observe(overlay, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  var bodyObserver = new MutationObserver(function() {
    var menuOpen = document.body.classList.contains('reveal-mobile-nav--revealed');
    document.body.classList.toggle('overlay-is-open',
      menuOpen || document.querySelector('.js-overlay')?.classList.contains('is-visible')
    );
  });
  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['class']
  });

  tryBindOverlay();
})();